import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const CaretIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className, color = "white"}) => (



<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6L8 10L4 6" stroke={color} stroke-width="2"/>
</svg>

);
